import React from 'react';
import { CategoryModel } from '../services/content/category/models/CategoryModel';

export const NavigationMenuContext = React.createContext<CategoryModel[]>([]);
